import React, { useState, useEffect } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Modal from 'react-bootstrap/Modal';
import { endPoints } from "../../Constants";
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import {PORTAL_URL} from '../../Constants';
import { useTranslation,Trans  } from 'react-i18next';
const UpcommingEvents = () => {
    const [myEvents, setMyEvents] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const { t,i18n } = useTranslation();
    useEffect(() => {
        const token = localStorage.getItem('token');      
        axios
            .get(`${endPoints.event}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {              
                const limitedEvents = res.data.slice(0, 100);                
                const upcomingEvents = limitedEvents.filter(event => event.isUpcoming === "Yes" && isEventUpcoming(event.eventDate));
                setMyEvents(upcomingEvents);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            });
    }, []);

    const removeDateSuffix = (dateString) => {
        return dateString.replace(/\d+(st|nd|rd|th)/, (match) => match.slice(0, -2));
    };
   
    const isEventUpcoming = (eventDate) => {
        // Parse eventDate
        const formattedDateString = removeDateSuffix(eventDate);

        const eventDateParsed = new Date(formattedDateString);

        // Get today's date
        const today = new Date();       
        today.setHours(0, 0, 0, 0);       
        return eventDateParsed >= today;
    };

    // Function to open modal with selected event
    const handleShow = (event) => {
        setSelectedEvent(event);
        setShowModal(true);
    };

    // Function to close modal
    const handleClose = () => setShowModal(false);

    return (
        <>
            <section className='lyt-section custom-margin-top'>
                <div className='container'>
                    <div className='bs-breadcrumb'>
                        <Breadcrumb>
                            <Breadcrumb.Item href="/">{t('home')}</Breadcrumb.Item>
                            <Breadcrumb.Item active> {t('upcomingEvents')} </Breadcrumb.Item>
                        </Breadcrumb>
                    </div>

                    <div className='heading-wrapper'>
                        <h2 className='bs-heading typdblue mb-2' data-aos="fade-in" data-aos-delay="200">{t('upcomingEvents')}</h2>
                        {/* <a  data-aos-delay="300" href='/event-listing'>Highlights from Our Events</a> */}
                    </div>

                    <div className='bs-grid-box'>
                        {myEvents.map((item, index) => {
                            const {
                                eventShortDes = 'No Description Available',
                                eventDate = 'Date Not Available',
                                isOngoing,
                                eventImageURL,
                                readMoreContent,
                                eventShortDesMr
                            } = item;

                            return (
                                <div
                                    key={index}
                                    className='bs-card typ-event'
                                    data-aos="fade-in"
                                    data-aos-delay="200"
                                >
                                    <div className='box-img'>
                                        <img
                                            className="img-fluid"
                                            src={eventImageURL || 'https://via.placeholder.com/384x297'}
                                            alt={eventShortDes}
                                            width={384}
                                            height={297}
                                        />
                                    </div>
                                    <div className='set-contentBox'>
                                        {isOngoing === "Yes" && (
                                            <div className='tag'>Ongoing Event</div>
                                        )}
                                        <div className='box-text'>
                                            <div className='title'>{ i18n.language==='mr'? eventShortDesMr: eventShortDes}</div>
                                            <div className='new-flex'>
                                                <div>
                                                    <div className='date'>{eventDate}</div>
                                                </div>
                                                <a
                                                    className="bs-btn typexplore"
                                                    onClick={() => handleShow(item)}
                                                    href='#'
                                                >
                                                  {t('exploreMore')} <span className="icon icon-right-arrow"></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* Modal for Event Details */}
            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    {/* <Modal.Title>{selectedEvent?.eventShortDes || "Event Details"}</Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                    {selectedEvent && (
                        <>
                            <img
                                src={selectedEvent.eventImageURL || 'https://via.placeholder.com/500'}
                                alt={selectedEvent.eventShortDes}
                                className="img-fluid mb-3 w-100"
                                // style={{ maxHeight: '300px', objectFit: 'cover', width: '100%' }}
                            />
                            <p className='bs-para typ-fw400 typ-16'>
                                { i18n.language==='mr'? selectedEvent.eventShortDesMr: selectedEvent.eventShortDes || "No further details available."}
                            </p>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <a className="bs-btn typfill" href={PORTAL_URL} target="_blank" aria-label="Navigate to Contact Us page" >
                     {t('registerforGRSF')}
                    </a>
                    <Button variant="secondary" onClick={handleClose}>
                        {t('close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default UpcommingEvents;
